import faEye from "icons/solid/eye.svg";
import faUserFriends from "icons/solid/users.svg";
import faWorld from "icons/solid/globe.svg";

export const PrivacyPublic = 1;
export const PrivacyFollows = 2;
export const PrivacyPrivate = 3;

export type PrivacySettingType = 1 | 2 | 3;

export const PrivacySettings = {
  [PrivacyPublic]: "Public",
  [PrivacyFollows]: "Follows",
  [PrivacyPrivate]: "Private",
};

export const PrivacyIcons = {
  [PrivacyPublic]: faWorld,
  [PrivacyFollows]: faUserFriends,
  [PrivacyPrivate]: faEye,
};

export const PrivacyLevels = [
  {
    id: 1,
    name: "Public",
    description: "Your activities will be visible to anyone.",
    engagement: "Anyone can interact with you."
  },
  {
    id: 2,
    name: "Followers only",
    description: "Your activities will be visible only to people who follow you.",
    engagement: "Only people you follow can interact with you."
  },
  {
    id: 3,
    name: "Private",
    description: "Only you can see your activities.",
    engagement: "No one can interact with you."
  }
]